.card {
  background: var(--vc-surface);
  border: 1px solid var(--vc-border);
  border-radius: var(--vc-radius-lg);
  box-shadow: var(--vc-shadow-sm);
  display: flex;
  flex-direction: column;
  min-width: 0;

  &.interactive {
    transition:
      box-shadow var(--vc-duration) var(--vc-ease),
      transform var(--vc-duration) var(--vc-ease),
      border-color var(--vc-duration) var(--vc-ease);
    cursor: pointer;

    &:hover {
      box-shadow: var(--vc-shadow-md);
      border-color: var(--vc-border-strong);
      transform: translateY(-1px);
    }
  }

  &.flat {
    box-shadow: none;
  }

  .header {
    display: flex;
    align-items: center;
    justify-content: space-between;
    gap: 12px;
    padding: 14px 18px;
    border-bottom: 1px solid var(--vc-border);
  }

  .headerTitle {
    display: flex;
    align-items: center;
    gap: 8px;
    min-width: 0;
  }

  .title {
    font-size: var(--vc-text-base);
    font-weight: var(--vc-weight-semibold);
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
  }

  .subtitle {
    font-size: var(--vc-text-xs);
    color: var(--vc-text-muted);
    white-space: nowrap;
  }

  .actions {
    display: flex;
    align-items: center;
    gap: 8px;
    flex: none;
  }

  // The body always carries its own inset; `padding="none"` only means the card itself adds none
  // (so a header or a table can sit flush with the card edge).
  .body {
    padding: 18px;
  }

  &.compact .body {
    padding: 14px;
  }

  .footer {
    padding: 12px 18px;
    border-top: 1px solid var(--vc-border);
    display: flex;
    align-items: center;
    justify-content: space-between;
    gap: 12px;
  }
}
